import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import {
  formatPersonName,
  localizeRelationType,
} from "Components/Migration/MerchantCreateIdentity/CandidatesList/utils";
import type { RelatedPartyCandidateDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Auth.Migration.MerchantCreateIdentity;

type Props = {
  relatedPartyCandidates: Array<RelatedPartyCandidateDto>;
  selectedPublicID: string | null;
  isDisabled: boolean;
  onSelect: (relatedPartyPublicID: string) => void;
};

export const CandidatesList = ({
  relatedPartyCandidates,
  selectedPublicID,
  isDisabled,
  onSelect,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">
        {t(COMPONENT_RESOURCES.PickPersonTitle)}
      </Typography>
      <List dense disablePadding>
        {relatedPartyCandidates.map((candidate) => {
          const secondary = candidate.isAlreadyLinkedToIdentity
            ? `${localizeRelationType(t, candidate.relationType)} — ${t(COMPONENT_RESOURCES.AlreadyLinkedHint)}`
            : localizeRelationType(t, candidate.relationType);
          const isSelected =
            candidate.relatedPartyPublicID === selectedPublicID;

          return (
            <ListItemButton
              key={candidate.relatedPartyPublicID}
              selected={isSelected}
              disabled={candidate.isAlreadyLinkedToIdentity || isDisabled}
              onClick={() => onSelect(candidate.relatedPartyPublicID)}
            >
              <ListItemIcon>
                <Radio
                  edge="start"
                  checked={isSelected}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={formatPersonName(
                  t,
                  candidate.firstName,
                  candidate.lastName,
                )}
                secondary={secondary}
                slotProps={{
                  primary: { variant: "body2" },
                  secondary: { variant: "caption" },
                }}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Stack>
  );
};
